import makeApiCall from "../master/axiosIndex";

const supplierRankDashboardApis = {
  supplierDetails: (params: any): Promise<any> => {
    return makeApiCall<any>({
      url: "/supplier-rank-dashboard/supplier-details",
      method: "get",
      params,
    });
  },
  scoreBreakdown: (params: any): Promise<any> => {
    return makeApiCall<any>({
      url: "/supplier-rank-dashboard/score-breakdown",
      method: "get",
      params,
    });
  },
  purchaseSummary: (params: any): Promise<any> => {
    return makeApiCall<any>({
      url: "/supplier-rank-dashboard/purchase-summary",
      method: "get",
      params,
    });
  },
  purchaseTrend: (params: any): Promise<any> => {
    return makeApiCall<any>({
      url: "/supplier-rank-dashboard/purchase-trend",
      method: "get",
      params,
    });
  },
  materialSummary: (params: any): Promise<any> => {
    return makeApiCall<any>({
      url: "/supplier-rank-dashboard/material-summary",
      method: "get",
      params,
    });
  },
  deliveryPatterns: (params: any): Promise<any> => {
    return makeApiCall<any>({
      url: "/supplier-rank-dashboard/delivery-patterns",
      method: "get",
      params,
    });
  },
  leadTimeTrend: (params: any): Promise<any> => {
    return makeApiCall<any>({
      url: "/supplier-rank-dashboard/lead-time-trend",
      method: "get",
      params,
    });
  },
  deliveryPatternsSummary: (params: any): Promise<any> => {
    return makeApiCall<any>({
      url: "/supplier-rank-dashboard/delivery-patterns-summary",
      method: "get",
      params,
    });
  },
  poDeliveryDetails: (params: any): Promise<any> => {
    return makeApiCall<any>({
      url: "/supplier-rank-dashboard/po-delivery-details",
      method: "get",
      params,
    });
  },
};

export default supplierRankDashboardApis;
